/* "Available across the GCC" — every country's home page, on every home page (the current country is marked). */
import { useI18n } from "../../../i18n";
import { Icon } from "../../../ui";
import { inCountry, useMktCountry } from "../mktCountry";
import { GCC } from "../mktLocal";
import { MktLink } from "./MktLink";

export function GccCountries() {
  const { L } = useI18n();
  const here = useMktCountry();
  return (
    <section className="mkt-sec" id="gcc" data-testid="gcc-sec">
      <div className="mkt-in">
        <div className="sec-h center">
          <span className="eyebrow">{L("Available across the GCC", "متاح في دول الخليج")}</span>
          <h2>{L("One StartHR, the rules of each Gulf country", "ستارت HR واحد بقواعد كل دولة خليجية")}</h2>
          <p className="muted" style={{ marginTop: 8 }}>{L("Pick your country to see its social insurance, wage protection, end-of-service and localisation rules — and a live demo company for every industry.", "اختر دولتك لتعرف قواعد التأمينات وحماية الأجور ونهاية الخدمة والتوطين فيها — مع شركة تجريبية مباشرة لكل قطاع.")}</p>
        </div>
        <div className="gcc-grid">
          {GCC.map((c) => {
            const on = c.code === here.code;
            return (
              <MktLink key={c.code} to={inCountry("/home", c)} className={"gcc-card" + (on ? " on" : "")} data-testid={"gcc-" + c.code.toLowerCase()} aria-current={on ? "page" : undefined}>
                <span className="gcc-flag" aria-hidden="true">{c.flag}</span>
                <span className="gcc-t">
                  <b>{L(...c.short)}</b>
                  <span className="xs muted">{L(`${c.si.short[0]} · WPS · ${c.currency.code}`, `${c.si.short[1]} · حماية الأجور · ${c.currency.symbol[1]}`)}</span>
                </span>
                {on ? <span className="chip ok xs">{L("You're here", "أنت هنا")}</span> : <Icon name="chevron-right" className="s gcc-go" />}
              </MktLink>
            );
          })}
        </div>
      </div>
    </section>
  );
}
